<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="p-4">
            <h5 class="text-dark">Pessoa Física</h5>
            <p>Selecione seu enquadramento</p>
            <div class="text-muted">
              <p class="mb-4">
                <i class="mdi mdi-arrow-right-thick align-middle text-primary mr-1"></i>
                <router-link
                    tag="a"
                    to="/contribuinte/solicitacao/fisica/autonomo"
                    class="font-weight-medium text-primary">
                  Autônomos - profissionais liberais (Contadores, Médicos, Dentistas, Engenheiros e etc). Com sede da
                  atividade profissional no município
                </router-link>
              </p>
              <p v-if="entidade.ent_cnpj === '07727569000100'" class="mb-4">
                <i class="mdi mdi-arrow-right-thick align-middle text-primary mr-1"></i>
                <router-link
                    tag="a"
                    to="/contribuinte/solicitacao/fisica/avulso"
                    class="font-weight-medium text-primary">
                  Avulsos - Contribuintes eventuais ou Profissionais Liberais estabelecidos em outros municípios
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card">
          <div class="p-4">
            <h5 class="text-dark">Pessoa jurídica</h5>
            <p>Selecione seu enquadramento</p>

            <div class="text-muted">
              <p class="mb-3">
                <i class="mdi mdi-arrow-right-thick align-middle text-primary mr-1"></i>
                <router-link
                    tag="a"
                    to="/contribuinte/solicitacao/juridica/prestador"
                    class="font-weight-medium text-primary">
                  Prestadores de Serviços (Apenas com sede no município)
                </router-link>
              </p>
              <p class="mb-3">
                <i class="mdi mdi-arrow-right-thick align-middle text-primary mr-1"></i>
                <router-link
                    tag="a"
                    to="/contribuinte/solicitacao/juridica/nao-prestador"
                    class="font-weight-medium text-primary">
                  Nao prestadores mas com retenção (Orgaos Públicos, Indústrias, Comercio e Lojas definidos como
                  substituto tributário)
                </router-link>
              </p>
              <p class="mb-3">
                <i class="mdi mdi-arrow-right-thick align-middle text-primary mr-1"></i>
                <router-link
                    tag="a"
                    to="/contribuinte/solicitacao/juridica/contabilidade"
                    class="font-weight-medium text-primary">
                  Escritórios de Contabilidade
                </router-link>
              </p>
              <p class="mb-0">
                <i class="mdi mdi-arrow-right-thick align-middle text-primary mr-1"></i>
                <router-link
                    tag="a"
                    to="/contribuinte/solicitacao/juridica/cartorio"
                    class="font-weight-medium text-primary">
                  Cartórios
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Solicitações Realizadas</h5>
            <TableSolicitacoes/>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import TableSolicitacoes from '@/router/views/contribuinte/components/table-solicitacoes'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Solicitações",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableSolicitacoes
  },
  data() {
    return {
      title: "Solicitações",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitações',
          active: true,
        },
      ],
    };
  },
  created() {
    this.entidade = this.$store.state.auth.currentEntidade;
  },
};
</script>


